module.exports = __webpack_public_path__ + "img/lark.0d4dd88c.png";